class AlternativeLoginRequiredException extends Error {
    public name = "AlternativeLoginRequiredException";
    constructor(message: string) {
        super(message);
    }
}

export default AlternativeLoginRequiredException;
